export enum FinancialMultipleCompaniesType {
	ByCustomer="ByCustomer", ByProduct="ByProduct"
}
